import { forwardRef } from 'react';
import { Button, type ButtonProps } from '@mui/material';
import { HFSpinner } from '../HFSpinner';

// `to` is accepted so HFButton can be used with `component={<RouterLink>}` for navigation.
export interface HFButtonProps extends ButtonProps {
  to?: string;
}

export const HFButton = forwardRef<HTMLButtonElement, HFButtonProps>(function HFButton(
  { variant = 'contained', color = 'primary', loadingIndicator, ...props },
  ref,
) {
  return (
    <Button ref={ref} variant={variant} color={color} loadingIndicator={loadingIndicator ?? <HFSpinner color="inherit" size={16} />} {...props} />
  );
});
